<template>
  <div>
    <banner-generic :data="data.hero"></banner-generic>

    <section class="padding--lg">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <div>
              <div class="form-success hide">
                  <h4>Thank you for your submission</h4>
              </div>
              <div class="form-failed hide">
                  <h4>Unfortunately we weren’t able to submit your request. Please contact our team directly on via our <a href="/contact">contact form</a> and we can organise your sample for you directly.</h4>
              </div>
              
              <magazine-form
                  :personas="data.personas"
                  :CompleteRedirectURL="data.CompleteRedirectURL"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { BannerGeneric, Cta, MagazineForm } from "../components";

export default {
  name: "v-sample",
  components: {
    BannerGeneric,
    MagazineForm,
    Cta,
  },
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      selectedColours: [],
      selectedBrochures: [],
      selectedSolutions: [],
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../scss/abstracts/variables";

h4 {
  a {
    text-decoration: underline;
  }
}

.form-success,
.form-failed {
  &.hide {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s 2s, opacity 2s linear;
    display: none;
  }

  &.show {
    visibility: visible;
    opacity: 1;
    transition: visibility 0s 2s, opacity 2s linear;
    display: block;
  }
}
</style>
